import { useState } from 'react';
import { mutateConfig } from '../../../../api/queryBase';
import { getErrorMessage, openNotification } from '../../../../utils/helper';
import CustomTextField from '../../../CustomTextInput';
import { DangerIcon } from '../../../icons';
import { SuitUIButton } from '../../../SuitUIButton';

export const RcNumberRejected = () => {
    const mutation = mutateConfig({ method: 'put' });
    const { mutate, isLoading } = mutation({
        url: `/corporates/update`,
        cacheKeys: 'users-profile'
    });

    const [rcNumber, setRcNumber] = useState('');

    const handleSubmit = () => {
        mutate(
            {
                rcNumber
            },
            {
                onSettled: (_, error) => {
                    if (error) {
                        openNotification(
                            'error',
                            getErrorMessage(error) || 'An error occurred'
                        );
                        return;
                    }

                    openNotification('info', 'RC number updated successfully');
                }
            }
        );
    };

    return (
        <div className='flex flex-col pt-[30px] items-center'>
            <div className='flex w-[36px] h-[36px] bg-white rounded-[50%] items-center justify-center'>
                <div className='flex w-[32px] h-[32px] bg-rose rounded-[50%] items-center justify-center'>
                    <DangerIcon />
                </div>
            </div>

            <p className='font-semibold text-ebony pt-4'>RC Number Rejected</p>
            <p className='text-sm text-midnightHaze max-w-[352px] text-center mb-6'>
                Your RC number has been rejected. Please review it and
                re-submit.
            </p>

            <div className='w-full max-w-[362px] pb-[24px] mb-4 border-b border-0 border-gray300'>
                <label className='text-sm font-medium mb-[10px] inline-block text-steelBlue'>
                    Reason for rejection
                </label>
                <CustomTextField
                    value='Your RC number was rejected. Kindly submit a corrected entry.'
                    onChange={() => {}}
                    disabled
                    height={120}
                    multiline
                />
            </div>

            <div className='w-full max-w-[362px] mb-4'>
                <label className='text-sm font-medium mb-[10px] inline-block text-steelBlue'>
                    Enter New RC Number
                </label>
                <CustomTextField
                    value={rcNumber}
                    onChange={(e) => setRcNumber(e.target.value)}
                />
            </div>

            <SuitUIButton
                text='Submit'
                disabled={!rcNumber}
                onClick={handleSubmit}
                isLoading={isLoading}
            />
        </div>
    );
};
